/**
 * The store's words for its nouns, from the resolved config: `terms.box.plural` wherever the
 * storefront would otherwise say "boxes".
 */
import {
  resolveStorefrontTerminology,
  type StorefrontTerminology,
  storefrontTerminologySchema,
} from "@loot-os/api-contract";
import { useMemo } from "react";

import { type TenantConfig, useTenant } from "./tenant.js";

const DEFAULTS = resolveStorefrontTerminology({});

/** Fail-safe read: a config cached before the field existed gets every default. */
export function terminologyOf(config: TenantConfig): StorefrontTerminology {
  const result = storefrontTerminologySchema.safeParse(
    (config as Partial<TenantConfig>).terminology,
  );
  return result.success ? result.data : DEFAULTS;
}

export function useTerminology(): StorefrontTerminology {
  const { config } = useTenant();
  return useMemo(() => terminologyOf(config), [config]);
}
